import { Tab } from 'ud-ui/components/tabs/interfaces';

type EditFormTabKey =
  | 'COMMON'
  | 'RULES'
  | 'STEPS'
  | 'TEAMS'
  // | 'GAMES'
  // | 'APPLICATIONS'
  | 'SYMBOLIC_TEAMS';
// | 'RESULTS';

export const TourneyEditFormPart: Record<EditFormTabKey, Tab> = {
  COMMON: { hash: 'common', label: 'Основные данные' },
  RULES: { hash: 'rules', label: 'Условия' },
  TEAMS: { hash: 'applications', label: 'Заявки' },
  STEPS: { hash: 'steps', label: 'Этапы' },
  SYMBOLIC_TEAMS: { hash: 'symbolic-teams', label: 'Сборные' },
};

export const defaultTab = TourneyEditFormPart.COMMON;
